import mixpanel from 'mixpanel-browser'

function attributesOf(user) {
  const attributes = { ...user }

  Object.keys(attributes).forEach((key) => {
    if (typeof attributes[key] == 'object' || Array.isArray(attributes[key])) delete attributes[key]
  })

  return attributes
}

const noopMixpanel = {
  init: () => {},
  track: () => {},
  identify: () => {},
  people: { set: () => {} },
  trackAuthEvent: () => {}
}

if (process.env.MIXPANEL_ENABLED === 'false' || !process.env.MIXPANEL_TOKEN) {
  Object.assign(mixpanel, noopMixpanel)
} else {
  mixpanel.trackAuthEvent = (event, currentUser, properties = {}) => {
    mixpanel.track(event, properties)
    mixpanel.identify(currentUser.id)
    mixpanel.people.set(attributesOf(currentUser))
  }
}

export default mixpanel
